export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/identification_perseus/become_a_seller.9095ba3.png";